export const makeTransparent = (hex?: string, opacity = 0.5): string => {
  if (!hex) {
    return 'rgba(0, 0, 0, 0)';
  }
  // Ensure opacity is between 0 and 1
  opacity = Math.max(0, Math.min(1, opacity));

  // Remove the hash if it exists
  hex = hex.replace(/^#/, '');

  if (!/^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex)) {
    return 'rgba(0, 0, 0, 0)';
  }

  if (hex.length === 3) {
    hex = hex.split('').map((value) => `${value}${value}`).join('');
  }

  // Parse the hex string into RGB values
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  if ([r, g, b].some((value) => Number.isNaN(value))) {
    return 'rgba(0, 0, 0, 0)';
  }

  // Return the rgba string
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};